module.exports = __webpack_public_path__ + "img/3.6b5061cc.png";